// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
    breakpointMobile: '1023'
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	},
  general: {
    breakpointMobile: '1023'
  }
}; 

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  if (typeof ProductList !== 'undefined') ProductList.prototype._catchError = function() {
    if (Utils.isNoFilterResult(this.totalProduct, this.eventType)) {
      var errorContent = Labels.error.noProducts;
      var template = '';
      if (!Utils.checkExistFilterOptionParam()) {
        if (Utils.isSearchPage()) {
          errorContent = Labels.search.resultEmpty.replace(/{{ terms }}/g, '<strong>' + Utils.stripHtml(Globals.queryParams.q) + '</strong>').replace(/{{ breakline }}/g, '<br />');
          template = this.getNoResultSearchTemplate()
            .replace(/{{content}}/g, errorContent)
            .replace(/{{link}}/g, "/collections/all")
            .replace(/{{label.seeAllProducts}}/g, Labels.search.seeAllProducts);
        } else if (Globals.queryParams.incollection_search) {
          errorContent = Labels.error.noFilterResult;
          template = this.getNoResultTemplate().replace(/{{content}}/g, errorContent);
          Utils.hideFilterTree();
        } else {
          errorContent = Labels.error.noFilterResult;
          template = this.getNoResultTemplate().replace(/{{content}}/g, errorContent);
        }
      } else {
        errorContent = Labels.error.noFilterResult;
        template = this.getNoResultTemplate().replace(/{{content}}/g, errorContent);
      }
      if (template != '') {
        this.$element.html(template);
      }
    }
  }

})();